// App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Home";
import Projects from "./Projects";
import About from "./About";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Contact from "./Contact";
import Cart from "./Cart";

function App() {
  const [isEnglish, setIsEnglish] = useState(true);
  const [theme, setTheme] = useState("light");
  const [showCart, setShowCart] = useState(false);

  const toggleLanguage = () => setIsEnglish((prev) => !prev);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    document.body.className = newTheme;
  };

  return (
    <Router>
      <div style={{ direction: isEnglish ? "ltr" : "rtl", fontFamily: "Arial" }}>
        <Navbar
          isEnglish={isEnglish}
          toggleLanguage={toggleLanguage}
          theme={theme}
          toggleTheme={toggleTheme}
          onCartClick={() => setShowCart(true)}
        />

        {/* ✅ Routes بدل activePage */}
        <Routes>
          <Route path="/" element={<Home isEnglish={isEnglish} theme={theme} />} />
          <Route path="/projects" element={<Projects isEnglish={isEnglish} theme={theme} />} />
          <Route path="/about" element={<About isEnglish={isEnglish} theme={theme} />} />
          <Route path="/contact" element={<Contact isEnglish={isEnglish} theme={theme} />} />
        </Routes>

        {/* ✅ العربة */}
        {showCart && (
          <div
            style={{
              position: "fixed",
              top: "60px",
              right: "20px",
              width: "320px",
              height: "400px",
              background: theme === "light" ? "#fff" : "#222",
              color: theme === "light" ? "#000" : "#fff",
              borderRadius: "12px",
              border: "1px solid #ccc",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              zIndex: 1000,
              overflowY: "auto",
              padding: "10px",
            }}
          >
            <button
              onClick={() => setShowCart(false)}
              style={{
                float: "right",
                background: "transparent",
                border: "none",
                fontSize: "18px",
                cursor: "pointer",
                color: theme === "light" ? "#000" : "#fff",
              }}
            >
              ✖
            </button>
            <Cart isEnglish={isEnglish} theme={theme} />
          </div>
        )}

        <Footer isEnglish={isEnglish} />
      </div>
    </Router>
  );
}

export default App;
